export default __webpack_public_path__ + "static/media/appstore.4f5ee3e9.png";